<template>
<div class="chapter">
<div class="inner_page">
<h1 class="front">Contents</h1>
<p class="toc"><a href="#/Text/Chapter01">1. <span class="mt">The Invitation</span></a></p>
<p class="toc"><span href="#/Text/Chapter02" title="Link target outside of Sample">2. <span class="mt">Midsomer Madness</span></span></p>
<p class="toc"><span href="#/Text/Chapter03" title="Link target outside of Sample">3. <span class="mt">The Woman in Black</span></span></p>
<p class="toc"><span href="#/Text/Chapter04" title="Link target outside of Sample">4. <span class="mt">Between the Lines</span></span></p>
<p class="toc"><span href="#/Text/Chapter05" title="Link target outside of Sample">5. <span class="mt">Hector Pulls It Off</span></span></p>
<p class="toc"><span href="#/Text/Chapter06" title="Link target outside of Sample">6. <span class="mt">Liam’s Story</span></span></p>
<p class="toc"><span href="#/Text/Chapter07" title="Link target outside of Sample">7. <span class="mt">Hunting in Full Steel</span></span></p>
<p class="toc1"><span href="#/Text/Chapter08" title="Link target outside of Sample">Coda</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?5949de64